import { AppService } from "app/services/app.service";

import { ConfigBIMulticonta } from "app/models/config-bi-multiconta.model";
import { Observable } from "rxjs";

export abstract class AbConfigBiMulticonta extends AppService {
  abstract getConfiguracaoBIMultiConta(): Observable<any>;
  abstract saveConfiguracaoBIMulticonta(cfg: ConfigBIMulticonta): Observable<any>;
  abstract deleteConfiguracaoBIMulticonta(id: number): Observable<any>;
}